


























import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import Cookie from 'js-cookie'
import { LangOption } from '@/config/langulage-config'
import $Api from '@api'
import { Form } from 'element-ui'

@Component
export default class UpdatePasswordComponent extends Vue {
    name = 'update-passwrod'
    ruleForm = {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirm: ''
    }

    @Prop()
    visible!: boolean

    @Emit('cancel')
    onCancel() {
        return true
    }

    @Emit('before-close')
    beforeClose() {
        return true
    }

    onConfirm() {
        if (this.ruleForm.newPassword !== this.ruleForm.newPasswordConfirm) {
            this.$message.error(this.$t('nav.password.newPasswordConfirm.error') as string)
            return
        }
        const params = {
            userId: this.$store.state.auth.authInfo.userId,
            ...this.ruleForm
        }
        $Api.userService.updatePassword(params).subscribe(
            (res: any) => {
                this.$message.success(this.$t('common.success') as string)
                this.onCancel()
                ;(this.$refs.form as Form).resetFields()
            },
            error => {
                this.$message.error(error.message)
            }
        )
    }
}
